import {
  UserDesignationInterface,
  UserProfileDataInterface,
} from '../../components/utils/interfaces';

export const UserProfileDataObject: UserProfileDataInterface = {
  id: '',
  email: '',
  personal_details: {
    name: '',
    date_of_birth: '',
    gender: {
      id: -1,
      name: '',
    },
    cv_urls: [],
    mobile: '',
    address: '',
    picture_url: '',
    experience_year: -1,
  },
  profile_status: {
    id: -1,
    name: '',
  },
  date_of_last_skill_matrix_session: '',
};

export const UserDesignationObject: UserDesignationInterface = {
  designation: {
    designation: '',
    designation_id: -1,
    start_date: new Date(),
    end_date: new Date(),
    designation_status: {
      id: -1,
      name: '',
    },
  },
};

export const SkillCategoryList = [
  { Frontend: 1 },
  { Backend: 2 },
  { Devops: 3 },
  { 'Quality Assurance': 4 },
  { Database: 5 },
  { Network: 6 },
  { Fullstack: 7 },
  { Cloud: 8 },
  { Mobile: 9 },
  { 'Machine Learning': 10 },
  { 'Data Science': 12 },
  { Graphics: 13 },
  { OS_Security: 14 },
  { 'Game Development': 15 },
  { 'AR/VR': 16 },
  { System_Design: 17 },
  { Other: 11 },
  { IoT: 18 },
  { 'Project Management': 19 },
];

export const SkillCategoryMapping: any = {
  Frontend: 'Frontend',
  Backend: 'Backend',
  Devops: 'Devops',
  Qa: 'Quality Assurance',
  Database: 'Database',
  Network: 'Network',
  Fullstack: 'Fullstack',
  Cloud: 'Cloud',
  Mobile: 'Mobile',
  ML: 'Machine Learning',
  dataScience: 'Data Science',
  Graphics: 'Graphics',
  OS_Security: 'OS_Security',
  gameDevelopment: 'Game Development',
  AR_VR: 'AR/VR',
  Other: 'Other',
  System_Design: 'System_Design',
  IoT: 'IoT',
  ProjectManagement: 'Project Management',
};

export const SkillCategoryOptionsSelect: any = Object.entries(
  SkillCategoryMapping
).map(([key, value]) => ({
  label: value,
  value: key,
}));

export const SkillTypeList = [{ 'Core Skill': 1 }, { 'Soft Skill': 2 }];
export const ClientEngagedTypeList = [
  { 'Fully Engaged': 1 },
  { 'Partially Engaged': 2 },
  { 'Not Engaged': 3 },
];
export const StatusTypeList = [{ Active: 1 }, { Inactive: 4 }];
